import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
export function useBooleanFilter(args) {
    const [setBoolFilterMutation] = useMutation(gql `
    mutation SetBool {
      setBoolFilter(id: $id, value: $value) @client {
        value @client
      }
    }
  `);
    function apply({ value }) {
        return setBoolFilterMutation({
            variables: {
                id: args.filter.id,
                value
            }
        });
    }
    return { apply };
}
//# sourceMappingURL=useBooleanFilter.js.map